import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class DeviceDimensionsService {
	width: number;
	height: number;

	setDimensions(w: number, h: number) {
		this.width = w;
		this.height = h;
	}
}
